 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"ed-collaborative-text-toolbar":"ed-collaborative-text-toolbar","ed-designer-canvas":"ed-designer-canvas","ed-designer-elements":"ed-designer-elements","ed-designer-elements-tools":"ed-designer-elements-tools","ed-designer-menu":"ed-designer-menu","ed-designer-image":"ed-designer-image","ed-designer-rectangle":"ed-designer-rectangle","ed-designer-text":"ed-designer-text","ed-designer-elements-tools-item":"ed-designer-elements-tools-item","ed-designer-elements-tools-item-background":"ed-designer-elements-tools-item-background"}[chunkId]||chunkId) + "." + {"chunk-0212cc36":"be4acf9d","chunk-062b679d":"b92f5ba5","chunk-10f2eb8a":"97059018","chunk-12653342":"66987f28","chunk-1595bb8c":"d72f7cd5","chunk-15cbe4b7":"f8981cb9","chunk-17a29508":"1dc5396d","chunk-1d0939f8":"ff62a85b","chunk-1e98059d":"d41216f4","chunk-21624e47":"22374625","chunk-227dbef7":"9a24bb13","chunk-266fa5f9":"91a8328d","chunk-2786b1df":"b4936a95","chunk-2d0aec6f":"0b3d58e6","chunk-2d0b28ed":"1d011424","chunk-2d0bd229":"987cdf8b","chunk-2d139704":"1ed4b08d","chunk-4b17e486":"77aad12e","chunk-ad96b782":"0790551a","chunk-9df81e62":"bf7409ba","chunk-2e334794":"15fcc833","chunk-32f9b7a0":"597b1c11","chunk-4af17917":"fbcfc37a","chunk-2d21354b":"da15d750","chunk-2fc1182f":"5c8a76b0","chunk-3239286c":"29fd5be3","chunk-3b094212":"7760d867","chunk-3fc715cc":"baa179d2","chunk-49635c28":"e5d2f070","chunk-499c8626":"27b58294","chunk-4ebcc5ce":"b27fa5bd","chunk-5061f440":"4dd8bcfb","chunk-510a54da":"e1d647bd","chunk-533f3197":"f8ab0ad4","chunk-5485d9da":"6a0b1a8c","chunk-5568f88c":"d911da31","chunk-58f269f2":"8f222365","chunk-59d44bd6":"0e406b0b","chunk-5e87cfa0":"93390ab6","chunk-5f880bd7":"6cd62a84","chunk-65ddb240":"bf686df0","chunk-71222996":"f17c6125","chunk-72dabbaa":"27d48f62","chunk-73525690":"8d9cf9f5","chunk-75fede1d":"3dcaa6aa","chunk-7fc90fba":"b6c09dc2","chunk-839d41f4":"891b65c7","chunk-9c74a1f2":"88a5f7d7","chunk-a7c834f4":"ebdbacc8","chunk-aa5e73b8":"17ed79fa","chunk-bb1da89a":"8f02e345","chunk-afd08640":"20d66e89","chunk-b6e35742":"d44a9e31","chunk-66e7c9aa":"3739e880","chunk-b7589a06":"3204f111","chunk-faeddb28":"c1ae9097","ed-collaborative-text-toolbar":"43755db9","chunk-6670e1c2":"a65fc7fd","chunk-7ebc7de2":"c9bb1110","chunk-c6129446":"fdb01b07","chunk-f031b908":"0c7facf5","chunk-3cd30be4":"7835633b","chunk-44bfa9d2":"466cfeff","chunk-a1eeac50":"cac79172","chunk-61fd68b7":"0ca5a8a4","chunk-12f73a74":"37c87d93","chunk-4642778e":"04d4e760","chunk-2d0cbea8":"7b2b16ef","chunk-67410e8c":"370aa53a","chunk-2d0d619d":"89ddfc32","chunk-6442a4c8":"44843fbf","chunk-201d1c15":"a4b3406d","chunk-4893a4c2":"d26a899d","chunk-53d971c1":"7bcafd9f","chunk-06fb5add":"facf9e3a","chunk-46c4805c":"139fc0cc","chunk-5bad74de":"2f8205e0","chunk-6c15f9b4":"13f3d860","chunk-a492d9ea":"8e0b7917","chunk-c201a58a":"aed0396d","chunk-05a7d7d1":"f6eba1ba","chunk-2a30137d":"0babb4f7","chunk-70eaa7b8":"858de179","chunk-735a9c90":"2cdec33e","chunk-8f2bb35c":"4e30e768","chunk-94336b1c":"fde108ee","chunk-9f4d7730":"e8100ea5","chunk-349b4d9a":"bf1e752d","chunk-61b53cee":"07e96020","chunk-6e737f20":"0a40a87a","chunk-6f2d0072":"d8f71fcf","ed-designer-canvas":"5250f4d1","ed-designer-elements":"d300b879","ed-designer-elements-tools":"dd04982a","ed-designer-menu":"ccd67a50","chunk-190ddc98":"d986d30f","chunk-a9c8cd2a":"ae5fc6e6","chunk-1aef520c":"7c998619","chunk-fcce195e":"168598ae","ed-designer-image":"c34ad512","ed-designer-rectangle":"d5fe3755","ed-designer-text":"cffe1329","ed-designer-elements-tools-item":"3936cecc","ed-designer-elements-tools-item-background":"59c55ed5","chunk-010071eb":"12d0f5f5","chunk-62e42a2e":"19c5af4e","chunk-b1b526b2":"64887936"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0212cc36":1,"chunk-062b679d":1,"chunk-10f2eb8a":1,"chunk-12653342":1,"chunk-1595bb8c":1,"chunk-15cbe4b7":1,"chunk-17a29508":1,"chunk-1d0939f8":1,"chunk-1e98059d":1,"chunk-21624e47":1,"chunk-227dbef7":1,"chunk-266fa5f9":1,"chunk-2786b1df":1,"chunk-2d139704":1,"chunk-4b17e486":1,"chunk-ad96b782":1,"chunk-9df81e62":1,"chunk-2e334794":1,"chunk-32f9b7a0":1,"chunk-4af17917":1,"chunk-2fc1182f":1,"chunk-3239286c":1,"chunk-3b094212":1,"chunk-3fc715cc":1,"chunk-49635c28":1,"chunk-499c8626":1,"chunk-4ebcc5ce":1,"chunk-5061f440":1,"chunk-510a54da":1,"chunk-533f3197":1,"chunk-5485d9da":1,"chunk-5568f88c":1,"chunk-58f269f2":1,"chunk-59d44bd6":1,"chunk-5e87cfa0":1,"chunk-5f880bd7":1,"chunk-65ddb240":1,"chunk-71222996":1,"chunk-72dabbaa":1,"chunk-73525690":1,"chunk-75fede1d":1,"chunk-7fc90fba":1,"chunk-839d41f4":1,"chunk-9c74a1f2":1,"chunk-a7c834f4":1,"chunk-aa5e73b8":1,"chunk-bb1da89a":1,"chunk-afd08640":1,"chunk-b6e35742":1,"chunk-66e7c9aa":1,"chunk-b7589a06":1,"chunk-faeddb28":1,"ed-collaborative-text-toolbar":1,"chunk-6670e1c2":1,"chunk-7ebc7de2":1,"chunk-c6129446":1,"chunk-f031b908":1,"chunk-3cd30be4":1,"chunk-44bfa9d2":1,"chunk-a1eeac50":1,"chunk-61fd68b7":1,"chunk-12f73a74":1,"chunk-4642778e":1,"chunk-67410e8c":1,"chunk-6442a4c8":1,"chunk-201d1c15":1,"chunk-4893a4c2":1,"chunk-53d971c1":1,"chunk-06fb5add":1,"chunk-46c4805c":1,"chunk-5bad74de":1,"chunk-6c15f9b4":1,"chunk-a492d9ea":1,"chunk-c201a58a":1,"chunk-05a7d7d1":1,"chunk-2a30137d":1,"chunk-70eaa7b8":1,"chunk-735a9c90":1,"chunk-8f2bb35c":1,"chunk-94336b1c":1,"chunk-9f4d7730":1,"chunk-349b4d9a":1,"chunk-61b53cee":1,"chunk-6e737f20":1,"chunk-6f2d0072":1,"ed-designer-canvas":1,"ed-designer-elements":1,"ed-designer-elements-tools":1,"ed-designer-menu":1,"chunk-190ddc98":1,"chunk-a9c8cd2a":1,"chunk-1aef520c":1,"chunk-fcce195e":1,"ed-designer-image":1,"ed-designer-rectangle":1,"ed-designer-text":1,"ed-designer-elements-tools-item":1,"ed-designer-elements-tools-item-background":1,"chunk-010071eb":1,"chunk-62e42a2e":1,"chunk-b1b526b2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"ed-collaborative-text-toolbar":"ed-collaborative-text-toolbar","ed-designer-canvas":"ed-designer-canvas","ed-designer-elements":"ed-designer-elements","ed-designer-elements-tools":"ed-designer-elements-tools","ed-designer-menu":"ed-designer-menu","ed-designer-image":"ed-designer-image","ed-designer-rectangle":"ed-designer-rectangle","ed-designer-text":"ed-designer-text","ed-designer-elements-tools-item":"ed-designer-elements-tools-item","ed-designer-elements-tools-item-background":"ed-designer-elements-tools-item-background"}[chunkId]||chunkId) + "." + {"chunk-0212cc36":"7057954b","chunk-062b679d":"c1f4ac05","chunk-10f2eb8a":"9c99ecb2","chunk-12653342":"b4782810","chunk-1595bb8c":"21e49535","chunk-15cbe4b7":"93b16ff3","chunk-17a29508":"f12662ae","chunk-1d0939f8":"22ce69df","chunk-1e98059d":"ad01ce12","chunk-21624e47":"f5e970c4","chunk-227dbef7":"2b493de4","chunk-266fa5f9":"26f9375a","chunk-2786b1df":"a2d7d1f7","chunk-2d0aec6f":"31d6cfe0","chunk-2d0b28ed":"31d6cfe0","chunk-2d0bd229":"31d6cfe0","chunk-2d139704":"f2021c39","chunk-4b17e486":"8102a2f6","chunk-ad96b782":"4c9111fd","chunk-9df81e62":"5e1bee28","chunk-2e334794":"39057ce1","chunk-32f9b7a0":"e381dc2a","chunk-4af17917":"3e007f5e","chunk-2d21354b":"31d6cfe0","chunk-2fc1182f":"f5512d4d","chunk-3239286c":"ec2f67d1","chunk-3b094212":"0e433876","chunk-3fc715cc":"a71add7c","chunk-49635c28":"273d227f","chunk-499c8626":"73879d4d","chunk-4ebcc5ce":"9ea96917","chunk-5061f440":"8b1f568c","chunk-510a54da":"37865ae8","chunk-533f3197":"d404fdf7","chunk-5485d9da":"3e50b408","chunk-5568f88c":"2c3a987b","chunk-58f269f2":"0e433876","chunk-59d44bd6":"c8561a84","chunk-5e87cfa0":"ef532544","chunk-5f880bd7":"1612bc97","chunk-65ddb240":"8847fc8b","chunk-71222996":"badf4083","chunk-72dabbaa":"0ab494d2","chunk-73525690":"5a0ffafe","chunk-75fede1d":"0e433876","chunk-7fc90fba":"10046f77","chunk-839d41f4":"03c9dbd2","chunk-9c74a1f2":"95a620ae","chunk-a7c834f4":"8570a497","chunk-aa5e73b8":"0e433876","chunk-bb1da89a":"256b771f","chunk-afd08640":"4f327dab","chunk-b6e35742":"1b91ff43","chunk-66e7c9aa":"739eaa19","chunk-b7589a06":"f57cb309","chunk-faeddb28":"0e433876","ed-collaborative-text-toolbar":"8826e093","chunk-6670e1c2":"9335e260","chunk-7ebc7de2":"8fb11f3f","chunk-c6129446":"5d2379c4","chunk-f031b908":"0e433876","chunk-3cd30be4":"f54d02ea","chunk-44bfa9d2":"00d9e787","chunk-a1eeac50":"db0aeaef","chunk-61fd68b7":"b0c37209","chunk-12f73a74":"c42e9734","chunk-4642778e":"ac71a98f","chunk-2d0cbea8":"31d6cfe0","chunk-67410e8c":"e706fc8c","chunk-2d0d619d":"31d6cfe0","chunk-6442a4c8":"79d4dda6","chunk-201d1c15":"2fd6112d","chunk-4893a4c2":"0ca28120","chunk-53d971c1":"4bc4840a","chunk-06fb5add":"80a4ce63","chunk-46c4805c":"fbf90287","chunk-5bad74de":"c8764776","chunk-6c15f9b4":"c41118e5","chunk-a492d9ea":"b89c7b48","chunk-c201a58a":"09dbd82d","chunk-05a7d7d1":"ccf8d0cf","chunk-2a30137d":"15a075f3","chunk-70eaa7b8":"69c3cf9c","chunk-735a9c90":"4ea0e5db","chunk-8f2bb35c":"352ac83c","chunk-94336b1c":"fec04e5b","chunk-9f4d7730":"2408b6ee","chunk-349b4d9a":"77288932","chunk-61b53cee":"0412c90c","chunk-6e737f20":"811dd469","chunk-6f2d0072":"e71a041a","ed-designer-canvas":"77651044","ed-designer-elements":"0b429f9f","ed-designer-elements-tools":"623f9a0c","ed-designer-menu":"31226304","chunk-190ddc98":"8e3890dd","chunk-a9c8cd2a":"a131d64a","chunk-1aef520c":"5b306f25","chunk-fcce195e":"0c50a1d8","ed-designer-image":"3d9d6a73","ed-designer-rectangle":"710a61d4","ed-designer-text":"cc2f6a9e","ed-designer-elements-tools-item":"1b643952","ed-designer-elements-tools-item-background":"a19995ea","chunk-010071eb":"cd531e94","chunk-62e42a2e":"d3cf129c","chunk-b1b526b2":"9da1b979"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
